module.exports = __webpack_public_path__ + "img/tabach_yes.a6152080.png";